export function updateMeasuringRow(rows, targetRow, values) {
    return rows.map((row) => row === targetRow ? { ...row, ...values } : row);
}

export function deleteMeasuringRow(rows, targetRow, options = {}) {
    const { markPersistedRowRemoved = true } = options;

    if (markPersistedRowRemoved && targetRow && targetRow.id) {
        return rows.map((row) => row === targetRow ? { ...row, mode: 'remove' } : row);
    }

    return rows.filter((row) => row !== targetRow);
}
